import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  IconCheckCircle,
  IconTimesCircle,
  IconInfoCircle
} from 'src/Components/Icon'
import { Text } from 'src/Components'

import styles from './Bullet.module.scss'

const getColor = ({ color, icon }) => {
  if (color) {
    return color
  }

  switch (icon) {
    case IconCheckCircle:
      return 'green'

    case IconTimesCircle:
      return 'red'

    case IconInfoCircle:
      return 'orange'

    default:
      return 'white'
  }
}

const Bullet = ({ refiMessage, values }) => (
  <Text className={styles.bullet} color='quiet' size='s'>
    <Text element='span' color={getColor(refiMessage)}>
      {React.createElement(refiMessage.icon)}
    </Text>
    <FormattedMessage {...refiMessage} values={values} />
  </Text>
)

export default Bullet
